import {
  deleteSubscribeWebhookDetailFromServer,
  getEventTypeFromServer,
  getWebhookDetailFromServer,
  getWebhookEventHistoryListAllFromServer,
  getWebhookEventHistoryListFromServer,
  getWebhookListFromServer,
  requestTestWithWebhookFromServer,
  retryFailedSubscribeWebhookFromServer,
  subscribeWebhookFromServer,
  updateSubscribeWebhookDetailFromServer,
} from "logic/services/Webhook/server";
import { actionController } from "../utils";
import { ServiceIdentifier } from "logic/services/Webhook/server/index.type";

export const webhookController = {
  //웹흑 목록 조회
  getWebhookList: (option?: {
    lastId?: number;
    offset?: number;
    limit?: number;
    order?: "ASC" | "DESC";
    eventName?: "TOKEN_KIT_TRANSFER" | "TRANSACTION";
    resourceIdentifier?: number;
    subscriptionIds?: number[];
  }) => {
    return actionController(async () => {
      try {
        const webhookList = await getWebhookListFromServer({
          query: {
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
            ...(option?.eventName && { eventName: option.eventName }),
            ...(option?.resourceIdentifier && {
              resourceIdentifier: option.resourceIdentifier,
            }),
            ...(option?.subscriptionIds && {
              subscriptionIds: option.subscriptionIds,
            }),
          },
        });
        return webhookList;
      } catch (e) {
        throw new Error("get_webhook_list_fail");
      }
    });
  },

  //웹훅 상세 조회
  getWebhookDetail: (subscriptionId: number) => {
    return actionController(async () => {
      try {
        const webhookList = await getWebhookDetailFromServer({
          query: {},
          params: {
            subscriptionId,
          },
        });
        return webhookList;
      } catch (e) {
        throw new Error("get_webhook_detail_fail");
      }
    });
  },

  //웹훅 구독 생성
  subscribeWebhook: (
    webhookUrl: string,
    name: string,
    eventName: "TOKEN_KIT_TRANSFER" | "TRANSACTION",
    option?: { resourceIdentifier?: number }
  ) => {
    return actionController(async () => {
      try {
        const subscribeWebhook = await subscribeWebhookFromServer({
          query: { eventName },
          data: {
            name,
            webhookUrl,
            ...(option?.resourceIdentifier && {
              resourceIdentifier: option.resourceIdentifier,
            }),
          },
        });
        return subscribeWebhook;
      } catch (e) {
        console.log(e.data);
        if (e.data.errorCode === "SUBS0004") {
          throw new Error("subscription_already_exists");
        }
        throw new Error("subscribe_webhook_fail");
      }
    });
  },

  //웹훅 수정
  updateSubscribeWebhook: (
    subscriptionId: number,
    option?: {
      name?: string;
      webhookUrl?: string;
      isActive?: boolean;
    }
  ) => {
    return actionController(async () => {
      try {
        const webhookInfo = await updateSubscribeWebhookDetailFromServer({
          params: { subscriptionId },
          data: {
            ...(option?.name && { name: option.name }),
            ...(option?.webhookUrl && { webhookUrl: option.webhookUrl }),
            ...(option?.isActive !== undefined && {
              isActive: option.isActive,
            }),
          },
          query: {},
        });
        return webhookInfo;
      } catch (e) {}
      throw new Error("update_webhook_info_fail");
    });
  },

  //웹훅 삭제
  deleteSubscribeWebhook: (subscriptionId: number) => {
    return actionController(async () => {
      try {
        const webhookDelete = await deleteSubscribeWebhookDetailFromServer({
          query: {},
          params: { subscriptionId },
        });
        return webhookDelete;
      } catch (e) {
        throw new Error("delete_webhook_fail");
      }
    });
  },

  //웹훅에서 지원하는 이벤트 타입 조회
  getWebhookEventType: (serviceIdentifier: "TOKEN_KIT" | "TRANSACTION") => {
    return actionController(async () => {
      try {
        const webhookEventType = await getEventTypeFromServer({
          query: { serviceIdentifier },
        });
        return webhookEventType;
      } catch (e) {
        throw new Error("get_webhook_events_fail");
      }
    });
  },

  //웹흑 이벤트 기록 목록 조회
  getWebhookEventHistoryList: (
    subscriptionId: number,
    option?: {
      serviceIdentifier?: "TOKEN_KIT" | "TRANSACTION";
      resourceIdentifier?: number;
      lastId?: number;
      offset?: number;
      limit?: number;
      order?: "ASC" | "DESC";
    }
  ) => {
    return actionController(async () => {
      try {
        const webhookHistory = await getWebhookEventHistoryListFromServer({
          params: { subscriptionId },
          query: {
            ...(option?.serviceIdentifier && {
              serviceIdentifier: option.serviceIdentifier,
            }),
            ...(option?.resourceIdentifier && {
              resourceIdentifier: option.resourceIdentifier,
            }),
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
          },
        });

        const subscriptionIds = [
          ...new Set(webhookHistory.data.map((id: any) => id.subscription_id)),
        ];

        const webhookList = await getWebhookListFromServer({
          query: {
            ...(subscriptionIds && {
              subscriptionIds: subscriptionIds,
            }),
          },
        });

        const webhookHistoryWithNames = webhookHistory.data.map(
          (historyItem) => {
            const matchingWebhook = webhookList.data.find(
              (webhookItem) =>
                webhookItem.subscription_id === historyItem.subscription_id
            );

            if (matchingWebhook) {
              return {
                ...historyItem,
                name: matchingWebhook.name, // matchingWebhook의 name을 추가
              };
            }

            // 일치하는 항목이 없으면 원본 그대로 반환
            return {
              ...historyItem,
              name: undefined,
            };
          }
        );

        // webhookHistoryWithNames는 total과 data 형태로 반환
        return {
          total: webhookHistory.total,
          data: webhookHistoryWithNames, // data는 업데이트된 목록
        };
      } catch (e) {
        throw new Error("get_webhook_history_list_fail");
      }
    });
  },

  //웹흑 이벤트 기록 목록 "전체" 조회
  getWebhookEventHistoryListALL: (option?: {
    serviceIdentifier?: ServiceIdentifier[];
    resourceIdentifier?: number[];
    lastId?: number;
    offset?: number;
    limit?: number;
    order?: "ASC" | "DESC";
  }) => {
    return actionController(async () => {
      try {
        const webhookHistory = await getWebhookEventHistoryListAllFromServer({
          params: {},
          query: {
            ...(option?.serviceIdentifier && {
              serviceIdentifiers: option.serviceIdentifier,
            }),
            ...(option?.resourceIdentifier && {
              resourceIdentifiers: option.resourceIdentifier,
            }),
            ...(option?.lastId && { lastId: option.lastId }),
            ...(option?.offset && { offset: option.offset }),
            ...(option?.limit && { limit: option.limit }),
            ...(option?.order && { order: option.order }),
          },
        });

        const subscriptionIds = [
          ...new Set(webhookHistory.data.map((id: any) => id.subscription_id)),
        ];

        const webhookList = await getWebhookListFromServer({
          query: {
            ...(subscriptionIds && {
              subscriptionIds: subscriptionIds,
            }),
          },
        });

        const webhookHistoryWithNames = webhookHistory.data.map(
          (historyItem) => {
            // webhookList.data에서 subscription_id가 일치하는 항목 찾기
            const matchingWebhook = webhookList.data.find(
              (webhookItem) =>
                webhookItem.subscription_id === historyItem.subscription_id
            );

            if (matchingWebhook) {
              return {
                ...historyItem,
                name: matchingWebhook.name, // matchingWebhook의 name을 추가
              };
            }

            // 일치하는 항목이 없으면 원본 그대로 반환
            return {
              ...historyItem,
              name: undefined,
            };
          }
        );

        // webhookHistoryWithNames는 total과 data 형태로 반환
        return {
          total: webhookHistory.total,
          data: webhookHistoryWithNames, // data는 업데이트된 목록
        };
      } catch (e) {
        throw new Error("get_webhook_history_list_fail");
      }
    });
  },

  //싫패한 웹훅 재시도
  retryFailedSubscribeWebhook: (subscriptionId: number, webhookId: number) => {
    return actionController(async () => {
      try {
        const retryWebhook = await retryFailedSubscribeWebhookFromServer({
          params: {
            subscriptionId,
            webhookId,
          },
          query: {},
        });
        return retryWebhook;
      } catch (e) {
        throw new Error("webhook_retry_fail");
      }
    });
  },

  //웹훅으로 테스트
  requestTestWebhook: (subscriptionId: number) => {
    return actionController(async () => {
      try {
        const testWebhook = await requestTestWithWebhookFromServer({
          params: {
            subscriptionId,
          },
          query: {},
        });
        return testWebhook;
      } catch (e) {
        throw new Error("webhook_test_fail");
      }
    });
  },
};
